import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Dialog } from '@material-ui/core';
import moment from 'moment-timezone';
import {
  parseDateMMDDYYYYSlashes,
  dateToMMDDYYYYHyphens,
} from '@mummssoftware/utils/dates';
import { AppContext } from '../../App/AppContext';
import { StylesDialogTitle } from './WrapperDivs';

const StyledDialog = styled(Dialog)`
  color: ${(props) => props.theme.palette.text.secondary};
`;

const StyledDialogMsgContainer = styled.div`
  margin-bottom: 1rem;
  font-size: ${(props) => props.theme.typography.body2.fontSize};
  fontweight: ${(props) => props.theme.typography.body2.fontWeight};
  lineheight: ${(props) => props.theme.typography.body2.lineHeight};
`;

const StyledDialogButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  & Button {
    margin-left: 5px;
    margin-right: 5px;
  }
`;

export const ApprovalConfDialog = ({
  showApprovalDialog,
  handleApprovalDialogClose,
  messages,
  isDoctor,
  handleApproveConfirmClick,
  recordedDate,
}) => {
  const { approvedMedsHash } = useContext(AppContext);

  const getApprovalDialogMessage = () => {
    if (isDoctor) {
      const today = new Date();
      return (
        <div>
          <FormattedMessage
            {...messages.docApprovalConfMSG}
            values={{
              date: moment(today.toLocaleDateString()).format('MM-DD-YYYY'),
            }}
          />
        </div>
      );
    }
    const date = new Date(recordedDate);

    return (
      <div>
        <FormattedMessage
          {...messages.nurseApprovalConfMSG}
          values={{
            date: moment(date.toLocaleDateString()).format('MM-DD-YYYY'),
          }}
        />
      </div>
    );
  };

  const generateApprovedMedsList = () => (
    <ul>
      {Object.entries(approvedMedsHash).map((med) => {
        // med is an array of [med_id, medication_object]
        const medDisplayRequirements =
          med[1] &&
          med[1].startdate_shifted &&
          med[1].drugdescription &&
          med[1].orderingphysicianname;

        if (medDisplayRequirements) {
          const medDate = dateToMMDDYYYYHyphens(
            parseDateMMDDYYYYSlashes(med[1].startdate_shifted),
          );
          return (
            <li key={med[1].id}>
              <FormattedMessage
                {...messages.approvalMedLine}
                values={{
                  medDescription: med[1].drugdescription || '',
                  medStartDate: medDate || '',
                  orderingPhys: med[1].orderingphysicianname || '',
                  orderingPhysCred: med[1].orderingphysiciancredentials || '',
                }}
              />
            </li>
          );
        }
        return null;
      })}
    </ul>
  );

  return (
    <StyledDialog onClose={handleApprovalDialogClose} open={showApprovalDialog}>
      <StylesDialogTitle id="meds-verbal-orders-dialog" disableTypography>
        <FormattedMessage {...messages.approveMedsDialogTitle} />
      </StylesDialogTitle>
      <DialogContent>
        <StyledDialogMsgContainer>
          {' '}
          {getApprovalDialogMessage()}
          {generateApprovedMedsList()}
        </StyledDialogMsgContainer>
        <StyledDialogButtonContainer>
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={() => {
              handleApproveConfirmClick(recordedDate, isDoctor);
            }}
          >
            <FormattedMessage {...messages.Submit} />
          </Button>

          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleApprovalDialogClose}
          >
            <FormattedMessage {...messages.Cancel} />
          </Button>
        </StyledDialogButtonContainer>
      </DialogContent>
    </StyledDialog>
  );
};
